module.exports = __webpack_public_path__ + "5866c2c688e22110ac70e41fcc536b70.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/cancel.svg
// module id = c+JI
// module chunks = 1